import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#D80027",
  d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFDA44",
  d: "m6.567 7.302 1.036 3.187h3.352l-2.71 1.973 1.036 3.188-2.714-1.969-2.714 1.969 1.04-3.188L2.18 10.49H5.53zM14.225 18.585l-.792-.976-1.172.455.68-1.055-.793-.98 1.215.324.684-1.054.066 1.256 1.218.323-1.176.45zM15.8 15.725l.375-1.2-1.027-.726 1.257-.02.37-1.2.408 1.191 1.256-.014-1.008.75.403 1.191-1.026-.726zM17.927 8.806l-.554 1.13.9.877-1.242-.178-.553 1.125-.216-1.238-1.246-.178 1.115-.586-.215-1.242.9.876zM14.26 5.385l-.094 1.252 1.168.473-1.224.3-.089 1.256-.66-1.068-1.224.3.81-.961-.665-1.064 1.167.473z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }